/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserReportSource } from './UserReportSource';
import {
    UserReportSourceFromJSON,
    UserReportSourceFromJSONTyped,
    UserReportSourceToJSON,
    UserReportSourceToJSONTyped,
} from './UserReportSource';
import type { UserReportCategory } from './UserReportCategory';
import {
    UserReportCategoryFromJSON,
    UserReportCategoryFromJSONTyped,
    UserReportCategoryToJSON,
    UserReportCategoryToJSONTyped,
} from './UserReportCategory';

/**
 * Schema for submitting a report.
 * @export
 * @interface UserReportCreate
 */
export interface UserReportCreate {
    /**
     * 
     * @type {UserReportCategory}
     * @memberof UserReportCreate
     */
    category: UserReportCategory;
    /**
     * 
     * @type {string}
     * @memberof UserReportCreate
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserReportCreate
     */
    description: string;
    /**
     * 
     * @type {UserReportSource}
     * @memberof UserReportCreate
     */
    source: UserReportSource;
    /**
     * 
     * @type {string}
     * @memberof UserReportCreate
     */
    page_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReportCreate
     */
    user_agent?: string | null;
}



/**
 * Check if a given object implements the UserReportCreate interface.
 */
export function instanceOfUserReportCreate(value: object): value is UserReportCreate {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function UserReportCreateFromJSON(json: any): UserReportCreate {
    return UserReportCreateFromJSONTyped(json, false);
}

export function UserReportCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserReportCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'category': UserReportCategoryFromJSON(json['category']),
        'title': json['title'],
        'description': json['description'],
        'source': UserReportSourceFromJSON(json['source']),
        'page_url': json['page_url'] == null ? undefined : json['page_url'],
        'user_agent': json['user_agent'] == null ? undefined : json['user_agent'],
    };
}

export function UserReportCreateToJSON(json: any): UserReportCreate {
    return UserReportCreateToJSONTyped(json, false);
}

export function UserReportCreateToJSONTyped(value?: UserReportCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': UserReportCategoryToJSON(value['category']),
        'title': value['title'],
        'description': value['description'],
        'source': UserReportSourceToJSON(value['source']),
        'page_url': value['page_url'],
        'user_agent': value['user_agent'],
    };
}

